module.exports = __webpack_public_path__ + "img/details.695da697.png";